/* eslint-disable react/prop-types */
import { Box, Grid, Paper, Tab, Typography } from '@material-ui/core';
import { useLocation } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { withCookies } from 'react-cookie';
import ChatUser from './addressNumber/ChatUser';
import MsgArea from './delivery/MsgArea';
import QuestionareUser from './questionnaireUser/QuestionnaireUser';
import SupponetUser from './supponetUser/SupponetUser';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import axios from 'axios';
import Common from '../Common';

const styles = (_theme) => ({
    root: {
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        flexDirection: 'column',
        margin: '30px',
    },
    title:{
        fontSize: '25px',
        marginTop: '30px',
        marginLeft: '25px'
    },
    ttl: {
        fontSize: '28px',
        height: '45px',
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
        maxWidth: 1800,
        minWidth: 1200
    },
    displayFlex: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    content: {
        width: '90%',
        minWidth: 1200,
    },
    content__mt: {
        marginTop: '15px',
    },
    verticalSpaece: {
        margin: '0px 0px 20px 0px',
    },
    outlineZero: {
        '&:focus': {
            outline: '0',
        },
    },
    box:{
        borderBottom: 'solid 1px rgba(0,0,0,0.1)',
    },
    marginBottom:{
        marginBottom: '50px'
    },
});

const Message = withCookies((props) => {
    const { classes, cookies } = props;
    const [value, setValue] = React.useState('0');
    const [userData, setUserData] = React.useState([]);
    const [displayNickName, setDisplayNickName] = React.useState('');
    //宛名連携機能を利用する場合は検索したカテゴリを依頼メッセージを送信する際に使用するため、ここで宣言する
    const [selectedKubunId, setSelectedKubunId] = React.useState('');
    const [selectedKubunName, setSelectedKubunName] = React.useState('');
    const availableAddress = cookies.get('AVAILABLE_ADDRESS') === 'TRUE' ? true : false;
    const availableSupponet = cookies.get('AVAILABLE_SUPPONET') === 'TRUE' ? true : false;
    const chatNameObj = cookies.get('COMMON_NAME_OBJ');
    const chatName = chatNameObj.CHAT_NAME;
    //ログインしたユーザーIDがない場合は、ログイン画面に戻す
    const supportedPersonId = cookies.get('supportedPersonId');
    if (supportedPersonId === '' || supportedPersonId === undefined) {
        window.location.href = '/';
        return;
    }
    const search = useLocation().search;
    const query = new URLSearchParams(search);
    //クエリストリングから取得したchatIdをサニタイジング
    let chatId = query.get('cid');
    if(chatId !== null){
        chatId = chatId
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
    }

    const handleChange = (_event, newValue) => {
        const selectedUserId = [];
        if(userData.length !== 0){
            userData.map((d) => {
                if(d.checked) {
                    const dupData = selectedUserId.filter((id) => id === d.userId);
                    if(dupData.length === 0) selectedUserId.push(d.userId);
                }
            });
        }
        if(selectedUserId.length !== 0){
            const res = window.confirm('選択中のユーザーがリセットされます。\n移動しますか？');
            if(res){
                setUserData([]);
                setValue(newValue);
            }
        }
        else{
            setUserData([]);
            setValue(newValue);
        }
    };

    useEffect(async () => {
        try{
            if(chatId !== null) await getNickName(chatId);
        }
        catch(err){
            window.alert(err);
        }
    }, []);

    const getNickName = async(chatId) => {
        return new Promise((resolve, reject) => {
            //TOKEN取得
            axios.post(
            `${Common.apiServerUrl()}/api/auth/token`,
                {},
                {
                    headers: {
                        'Authorization': 'Bearer ' + cookies.get('id_token')
                    },
                }
            )
            .then(Common.handleErrors)
            .then((Response) => {
                if (Response.success) {
                    cookies.set('token', Response.token, {
                        maxAge: 60 * 60 * 24 * 30, //30日間
                        httpOnly: false,
                        path: '/',
                        secure: true,
                    });

                    const jichitaiToken = cookies.get('x-jichitai-token');
                    const jichitaiId = cookies.get('x-jichitai-jichitaiid');

                    //-------------------------------------------
                    //プルダウンに表示する情報区分の取得 APIアクセス先(johoKubun.js)
                    //cookieに保存している職員番号でGetアクセスを行う
                    //-------------------------------------------
                    // -------------------------axios------------------------------
                    axios.get(
                        `${Common.apiServerUrl()}/api/counseling_log/displayName`,
                        {
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                                'x-suppportcenter-token': Response.token,
                                'x-jichitai-jichitaiid': jichitaiId,
                                'x-jichitai-token': jichitaiToken,
                            },
                            params: {
                                chatId
                            }
                        })
                        .then(Common.handleErrors)
                        .then((response) => {
                            if (response.success) {
                                setDisplayNickName(response.nickName);
                                setSelectedKubunId(response.counselingKubunId);
                                setSelectedKubunName(response.counselingKubunName);
                                resolve();
                            } else {
                                reject(`code : [${response.type}]\nmessage : ${response.message}\nエラーが発生しました。画面を閉じてください。`);
                                window.close();
                            }
                        })
                        .catch((err) => {
                            reject('getNickName.js :get err1:' + err.message);
                        });
                }
            })
            .catch((err) => {
                reject('getNickName.js :get err2:' + err.message);
            });
        });
    };

    document.title = 'ユーザー選択';

    let displayFlg = '';
    //※宛名連携機能を利用する場合はそのタブのみ表示
    if(availableAddress) displayFlg = '1';
    //通報機能を利用する場合
    else if(availableSupponet) displayFlg = '2';
    //宛名連携機能と通報機能のどちらも利用しない場合（アンケートのみ表示）
    else displayFlg = '3';

    //-----------------------------------------------------------------
    // 表示
    //-----------------------------------------------------------------
    return (
        <React.Fragment>
            <Grid container justifyContent="center" direction="column" alignItems="center">
                { chatId === null && (
                    <>
                        <Grid container item justifyContent="center" alignItems="center" className={classes.content + ' ' + classes.content__mt} xs={10}>
                            <Typography className={classes.ttl}>{'ユーザー選択'}</Typography>
                        </Grid>
                        <Grid item xs={10} className={classes.content + ' ' + classes.content__mt}>
                            <Paper className={classes.paper} elevation={3}>
                                {displayFlg === '1' && (
                                    <Box sx={{ width: '100%', typography: 'body1' }}>
                                        <TabContext value={value}>
                                            <Box className={classes.box}>
                                                <TabList
                                                    value={value}
                                                    indicatorColor="primary"
                                                    textColor="primary"
                                                    variant="scrollable"
                                                    scrollButtons="auto"
                                                    onChange={handleChange}
                                                >
                                                    <Tab
                                                        className={classes.outlineZero}
                                                        label={chatName}
                                                        value="0" />
                                                </TabList>
                                            </Box>
                                            <TabPanel value="0">
                                                <ChatUser
                                                    userData={userData}
                                                    setUserData={setUserData}
                                                    selectedKubunId={selectedKubunId}
                                                    setSelectedKubunId={setSelectedKubunId}
                                                    setSelectedKubunName={setSelectedKubunName}
                                                />
                                            </TabPanel>
                                        </TabContext>
                                    </Box>
                                )}
                                {displayFlg === '2' && (
                                    <Box sx={{ width: '100%', typography: 'body1' }}>
                                        <TabContext value={value}>
                                            <Box className={classes.box}>
                                                <TabList
                                                    value={value}
                                                    indicatorColor="primary"
                                                    textColor="primary"
                                                    variant="scrollable"
                                                    scrollButtons="auto"
                                                    onChange={handleChange}
                                                >
                                                    <Tab
                                                        className={classes.outlineZero}
                                                        label="通報機能"
                                                        value="0" />
                                                    <Tab
                                                        className={classes.outlineZero}
                                                        label="アンケート"
                                                        value="1" />
                                                </TabList>
                                            </Box>
                                            <TabPanel value="0">
                                                <SupponetUser userData={userData} setUserData={setUserData} />
                                            </TabPanel>
                                            <TabPanel value="1">
                                                <QuestionareUser userData={userData} setUserData={setUserData} />
                                            </TabPanel>
                                        </TabContext>
                                    </Box>
                                )}
                                {displayFlg === '3' && (
                                    <Box sx={{ width: '100%', typography: 'body1' }}>
                                        <TabContext value={value}>
                                            <Box className={classes.box}>
                                                <TabList
                                                    value={value}
                                                    indicatorColor="primary"
                                                    textColor="primary"
                                                    variant="scrollable"
                                                    scrollButtons="auto"
                                                    onChange={handleChange}
                                                >
                                                    <Tab
                                                        className={classes.outlineZero}
                                                        label="アンケート"
                                                        value="0" />
                                                </TabList>
                                            </Box>
                                            <TabPanel value="0">
                                                <QuestionareUser userData={userData} setUserData={setUserData} />
                                            </TabPanel>
                                        </TabContext>
                                    </Box>
                                )}
                            </Paper>
                        </Grid>
                    </>
                )}
                <Grid item xs={10} className={classes.content + ' ' + classes.content__mt + ' ' + classes.marginBottom}>
                    <Paper className={classes.paper} elevation={3}>
                        <MsgArea
                            userData={userData}
                            nickName={displayNickName}
                            selectedKubunName={selectedKubunName}
                            selectedKubunId={selectedKubunId}
                            setSelectedKubunId={setSelectedKubunId}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </React.Fragment>
    );
});

Message.propTypes = {
    classes: PropTypes.object.isRequired,
    cookies: PropTypes.object.isRequired,
};

export default withStyles(styles)(Message);
